import React, { useState } from "react";
import "./Quiz.css"; // Importamos el archivo CSS para estilos

const questions = [
    {
        id: 1,
        question: "Si tu boda fuera una película, ¿cuál sería su estilo?",
        dimension: "Tradicional clásico/ Moderno alternativo",
        options: [
            { text: "Romántico Clásico", points: 1 },
            { text: "Moderno y Diferente", points: 3 },
            { text: "Minimalista y Íntimo", points: 2 },
            { text: "Espectacular y Lujoso", points: 3 }
        ]
    },
    {
        id: 2,
        question: "¿Cómo definirías el enfoque económico de tu boda?",
        dimension: "Dinero/Presupuesto",
        options: [
            { text: "Austero pero bonito", points: 1 },
            { text: "Balanceado", points: 2 },
            { text: "Sin límites", points: 3 }
        ]
    },
    {
        id: 3,
        question: "¿Cuánto te involucrarás en la planificación?",
        dimension: "Implicación/Organización",
        options: [
            { text: "Confío en los expertos", points: 1 },
            { text: "Quiero tomar decisiones clave", points: 2 },
            { text: "Voy a estar en todo", points: 3 }
        ]
    },
    {
        id: 4,
        question: "¿Cómo imaginas tu boda?",
        dimension: "Espectacularidad",
        options: [
            { text: "Íntima y sencilla", points: 1 },
            { text: "Elegante pero sin excesos", points: 2 },
            { text: "Un espectáculo que todos recordarán", points: 3 }
        ]
    },
    {
        id: 5,
        question: "Cuando tomas decisiones, ¿cómo las manejas?",
        dimension: "Coherencia",
        options: [
            { text: "Decido y mantengo mi elección", points: 3 },
            { text: "Me gusta probar opciones antes de decidir", points: 2 },
            { text: "Me cuesta decidir, cambio de idea frecuentemente", points: 1 }
        ]
    },
    {
        id: 6,
        question: "¿Cómo de importante es la boda en tu vida?",
        dimension: "Expectativas",
        options: [
            { text: "Es un evento especial, pero sin presiones", points: 1 },
            { text: "Es una gran celebración, debe salir bien", points: 2 },
            { text: "Debe ser perfecta, cada detalle cuenta", points: 3 }
        ]
    },
    {
        id: 7,
        question: "¿Cómo manejas las decisiones con proveedores?",
        dimension: "Negociación",
        options: [
            { text: "Acepto sugerencias sin pelear", points: 1 },
            { text: "Negocio algunos aspectos clave", points: 2 },
            { text: "Soy exigente y lo reviso todo", points: 3 }
        ]
    },
    {
        id: 8,
        question: "¿Cómo será la toma de decisiones con tu pareja?",
        dimension: "Implicación/Organización",
        options: [
            { text: "Decidimos juntos, sin estrés", points: 2 },
            { text: "Yo llevo el control, mi pareja confía en mí", points: 3 },
            { text: "Cada uno tiene ideas distintas", points: 1 }
        ]
    }
];

const personas = [
    {
        name: "Carolina 'La Minimalista Confiada'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 1, "Edad": 1, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 1, "Coherencia": 3, "Expectativas": 1, "Negociación": 1 }
    },
    {
        name: "Javier y Marta 'Los Soñadores Demandantes'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 2, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 3, "Coherencia": 3, "Expectativas": 3, "Negociación": 3 }
    },
    {
        name: "María 'La Clásica Económica'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 1, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 1, "Coherencia": 1, "Expectativas": 2, "Negociación": 1 }
    },
    {
        name: "Alejandro y Sofía 'Los Modernos Creativos'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 2, "Edad": 1, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 2, "Coherencia": 3, "Expectativas": 2, "Negociación": 2 }
    },
    {
        name: "Teresa 'La Perfeccionista de Alto Nivel'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 2, "Espectacularidad": 3, "Coherencia": 3, "Expectativas": 3, "Negociación": 3 }
    },
    {
        name: "Pedro y Ana 'Los Indecisos Pragmático'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 2, "Edad": 2, "Tradicional clásico/ Moderno alternativo": 2, "Espectacularidad": 1, "Coherencia": 1, "Expectativas": 2, "Negociación": 2 }
    },
    {
        name: "Laura 'La Clásica Apasionada'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 3, "Coherencia": 2, "Expectativas": 3, "Negociación": 3 }
    },
    {
        name: "Juan 'El Relajado Práctico'",
        dimensions: { "Dinero/Presupuesto": 2, "Implicación/Organización": 1, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 1, "Coherencia": 3, "Expectativas": 1, "Negociación": 1 }
    },
    {
        name: "Sergio 'El Pragmático de Negocios'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 1, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 2, "Espectacularidad": 1, "Coherencia": 3, "Expectativas": 2, "Negociación": 1 }
    },
    {
        name: "Claudia y Luis 'Los Creativos Soñadores'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 3, "Edad": 1, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 2, "Coherencia": 1, "Expectativas": 3, "Negociación": 2 }
    },
    {
        name: "Natalia y Fernando 'Los Tradicionalistas Entusiastas",
        dimensions: { "Dinero/Presupuesto": 2, "Implicación/Organización": 2, "Edad": 2, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 3, "Coherencia": 3, "Expectativas": 3, "Negociación": 1 }
    },
    {
        name: "Paula 'La Rebelde Alternativa'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 2, "Edad": 2, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 2, "Coherencia": 1, "Expectativas": 2, "Negociación": 3 }
    },
    {
        name: "Roberto y Elena 'Los Simples Tranquilos'",
        dimensions: { "Dinero/Presupuesto": 2, "Implicación/Organización": 1, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 1, "Coherencia": 3, "Expectativas": 1, "Negociación": 1 }
    },
    {
        name: "Valeria y Andrés 'Los Perfeccionistas Creativos'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 2, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 3, "Coherencia": 3, "Expectativas": 3, "Negociación": 3 }
    },
    {
        name: "Lorena 'La Ecléctica Despreocupada'",
        dimensions: { "Dinero/Presupuesto": 1, "Implicación/Organización": 1, "Edad": 1, "Tradicional clásico/ Moderno alternativo": 3, "Espectacularidad": 1, "Coherencia": 1, "Expectativas": 1, "Negociación": 1 }
    },
    {
        name: "Antonio y Carmen 'Los Sobrios Coherentes'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 3, "Coherencia": 3, "Expectativas": 3, "Negociación": 1 }
    },
    {
        name: "Isabel 'La Perfeccionista Clásica'",
        dimensions: { "Dinero/Presupuesto": 3, "Implicación/Organización": 3, "Edad": 3, "Tradicional clásico/ Moderno alternativo": 1, "Espectacularidad": 2, "Coherencia": 3, "Expectativas": 3, "Negociación": 3 }
    }
];

export default function PersonaExperienceQuestionary() {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [scores, setScores] = useState({
        "Dinero/Presupuesto": 0,
        "Implicación/Organización": 0,
        "Edad": 0,
        "Tradicional clásico/ Moderno alternativo": 0,
        "Espectacularidad": 0,
        "Coherencia": 0,
        "Expectativas": 0,
        "Negociación": 0
    });
    const [email, setEmail] = useState("");
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [result, setResult] = useState(null);

    const handleAnswer = (option, dimension) => {
        setScores((prev) => ({
            ...prev,
            [dimension]: prev[dimension] + option.points
        }));

        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
        } else {
            setShowEmailForm(true);
        }
    };

    const calculateResult = () => {
        let bestMatch = null;
        let bestScore = Infinity;

        personas.forEach((persona) => {
            let scoreDifference = Object.keys(scores).reduce((total, dimension) => {
                return total + Math.abs(scores[dimension] - persona.dimensions[dimension]);
            }, 0);

            if (scoreDifference < bestScore) {
                bestScore = scoreDifference;
                bestMatch = persona.name;
            }
        });

        setResult(bestMatch);
    };

    return (
        <div className="quiz-container">
            {!showEmailForm ? (
                <div className="question-card">
                    <h2>{questions[currentQuestion].question}</h2>
                    <div className="options-container">
                        {questions[currentQuestion].options.map((option, index) => (
                            <button key={index} className="option-button" onClick={() => handleAnswer(option, questions[currentQuestion].dimension)}>
                                {option.text}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="email-form-container">
                    {!result ? (
                        <div>
                            <h3>Déjanos tu email para recibir tu resultado:</h3>
                            <input type="email" className="email-input" placeholder="Tu email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            <button className="submit-button" onClick={calculateResult}>Ver mi resultado</button>
                        </div>
                    ) : (
                        <h2 className="result-text">Tu perfil ideal es: {result}</h2>
                    )}
                </div>
            )}
        </div>
    );
}
